// Legacy shim — re-exports from the new modular `src/api/` layer so existing
// imports keep working. New code should import directly from `../api`.
import { campaignsApi, leadsApi, callsApi, analyticsApi } from '../api';

export const campaignAPI = {
  getAll: (status = null) => campaignsApi.list(status),
  getById: (id) => campaignsApi.get(id),
  create: (campaign) => campaignsApi.create(campaign),
  update: (id, updates) => campaignsApi.update(id, updates),
};

export const leadAPI = {
  getAll: (filters = {}) =>
    leadsApi.list({
      campaignId: filters.campaign_id,
      status: filters.status,
      limit: filters.limit,
    }),
  getById: (id) => leadsApi.get(id),
  create: (lead) => leadsApi.create(lead),
  createBulk: (leads) => leadsApi.createBulk(leads),
};

export const callAPI = {
  getAll: (filters = {}) =>
    callsApi.list({
      campaignId: filters.campaign_id,
      leadId: filters.lead_id,
      status: filters.status,
      limit: filters.limit,
    }),
  getById: (id) => callsApi.get(id),
  initiate: (callData) => callsApi.initiate(callData),
};

export const analyticsAPI = {
  getKPIs: () => analyticsApi.kpis(),
  getCharts: () => analyticsApi.charts(),
};
